<template>
  <v-container class="cmpbk black--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

    <div id="app">
      <!-- <a
        href="https://renopd.com/missing/#casper"
        target="_blank"
        title="Jennifer Casper-Ross"
      > -->

      <!-- Spotlight -->
      <v-row id="rowredpsotlight" class="mb-4">
        <v-col cols="12">
          <v-card elevation="2">
            <v-card-text class="black--text">
              <!-- intro dialog -->
              <h4 class="mb-1" style="font-size: 1.5rem">Introduction</h4>
              Agencies across the country have utilized Card Decks to generate
              new or fresh case information pertaining to long stagnate Missing
              Person / Cold Cases. The card decks are distributed at prisons and
              jails in the Western United States.
              <br />

              Each card gives a short description of the crime and victim with
              the hope of getting tips from those who are incarcerated. Agencies
              who have utilized this unique tool are reporting a 10-15% increase
              in solvability rate after distributing decks to prisons and jails
              in their region.
              <br />
              RPD received a grant from Seasons of Justice and donations from
              Secret Witness to purchase the physical decks. The Reno Police
              Department is very grateful for the financial assistance in making
              this important project possible.
              <br />
              If you or anyone you know has information about a case, please
              email
              <a href="mailto:RPDcoldcases@reno.gov">RPDcoldcases@reno.gov</a>
              or anonymously contact
              <a href="https://secretwitness.com/" target="_black"
                >Secret Witness</a
              >.
              <!-- podcasts -->
              <h4 class="my-2" style="font-size: 1.5rem">Podcasts</h4>
              <!-- chia -->
              <v-row class="podcasts chia d-flex flex-row">
                <v-col class="pod-pic col-sm-12 col-lg-3">
                  <img
                    src="../images/podcast/thedeck_logo.jpg"
                    style="width: 100%"
                  />
                </v-col>
                <v-col class="pod-text d-flex flex-column col-sm-12 col-lg-8">
                  <a
                    class="blue--text"
                    href="https://thedeckpodcast.com/charles-jennifer-chia/"
                    target="_blank"
                    title="Charles & Jennifer Chia"
                    ><h2>
                      Charles & Jennifer Chia - Jack of Diamonds, Nevada - The
                      Deck
                    </h2></a
                  >
                  <span
                    >Charles and Jennifer Chia could see their apartment complex
                    from their school bus stop – that’s how close to their
                    building it was.</span
                  >
                  <a
                    href="https://thedeckpodcast.com/"
                    target="_blank"
                    title="the deck podcast"
                    >thedeckpodcast.com
                  </a>
                </v-col>
              </v-row>
              <!-- Beatty -->
              <v-row class="podcasts beatty d-flex flex-row">
                <v-col class="pod-pic col-sm-12 col-lg-3">
                  <img
                    src="../images/podcast/APB_logo.jpg"
                    style="width: 100%"
                  />
                </v-col>
                <v-col class="pod-text d-flex flex-column col-sm-12 col-lg-8">
                  <a
                    class="blue--text"
                    href="https://rss.com/podcasts/apbcoldcase/1311808/"
                    target="_blank"
                    title="Charles & Jennifer Chia"
                    ><h2>Jill Beatty - APB Cold Case</h2></a
                  >
                  <span
                    >A young, deaf woman moves to Reno to escape a troubled
                    relationship. But did trouble follow right behind her? One
                    fateful night she visits a friend at a casino near her
                    apartment – and after leaving alone and on foot, she’s never
                    seen again.</span
                  >
                  <a
                    href="https://apbcoldcase.com/"
                    target="_blank"
                    title="APB Cold Case"
                    >apbcoldcase.com</a
                  >
                </v-col>
              </v-row>
              <!-- Kirsten Leonard -->
              <v-row class="podcasts beatty d-flex flex-row">
                <v-col class="pod-pic col-sm-12 col-lg-3">
                  <img
                    src="../images/podcast/TheDeck_PlayingCards_square.jpg"
                    style="width: 100%"
                  />
                </v-col>
                <v-col class="pod-text d-flex flex-column col-sm-12 col-lg-8">
                  <a
                    class="blue--text"
                    href="https://podcasts.apple.com/us/podcast/the-deck/id1603011962?i=1000652706263"
                    target="_blank"
                    title="Kirsten Leonard"
                    ><h2>Kirsten Leonard - 9 of Spades</h2></a
                  >
                  <span
                    >A while back, our team at audiochuck received an email from
                    Kirsten Leonard’s family asking us if we would cover her
                    case. Specifically, the email was sent by her nephew,
                    Karsten, who’s named in memory of his aunt… an aunt he never
                    got the chance to meet.<br />
                    That’s because in June 1986, at just 22 years old, Kirsten
                    was murdered in what can only be described as a senseless
                    and brutal crime.</span
                  >
                  <a
                    href="https://thedeckpodcast.com/"
                    target="_blank"
                    title="the deck podcast"
                    >thedeckpodcast.com
                  </a>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-title style="word-break: break-word" class="pb-0">
              <h3>Missing Person Spotlight</h3>
            </v-card-title>
            <div class="d-flex flex-column justify-start ml-4">
              <h4 class="mt-0">Click on card(s) to see more.</h4>

              <div class="ml-0">
                <v-btn
                  @click="increment"
                  elevation="2"
                  color="rpdbutton"
                  light
                  class="white--text"
                  >Next Card</v-btn
                >
              </div>
            </div>
            <v-row id="cards-spot" class="spotimage">
              <v-col
                class="d-flex flex-lg-row px-lg-4 justify-lg-space-around justify-sm-space-around flex-sm-row flex-sm-wrap flex-column align-center col-lg-12"
                cols="12"
              >
                <div class="d-flex flex-column single-spot">
                  <a
                    class="mt-2"
                    :href="cards[cardindex].href.toString()"
                    target="_blank"
                    :title="cards[cardindex].name"
                    ><img
                      :src="cards[cardindex].src"
                      :lazy-src="cards[cardindex].src"
                      class=""
                  /></a>
                </div>

                <div class="d-flex flex-column single-spot">
                  <a
                    class="d-none d-sm-flex mt-2"
                    :href="cards[cardindex2].href.toString()"
                    target="_blank"
                    :title="cards[cardindex2].name"
                    ><img
                      :src="cards[cardindex2].src"
                      :lazy-src="cards[cardindex2].src"
                      class=""
                  /></a>
                </div>

                <div class="d-flex flex-column single-spot">
                  <a
                    class="d-none d-sm-flex mt-2"
                    :href="cards[cardindex3].href.toString()"
                    target="_blank"
                    :title="cards[cardindex3].name"
                  >
                    <img
                      :src="cards[cardindex3].src"
                      :lazy-src="cards[cardindex3].src"
                      class=""
                  /></a>
                </div>

                <div class="d-flex flex-column single-spot">
                  <a
                    class="d-none d-sm-flex mt-2"
                    :href="cards[cardindex4].href.toString()"
                    target="_blank"
                    :title="cards[cardindex4].name"
                    ><img
                      :src="cards[cardindex4].src"
                      :lazy-src="cards[cardindex4].src"
                      class=""
                  /></a>
                </div>
              </v-col>
              <!-- <v-col>
                <div class="d-sm-none d-flex flex-column justify-start">
                  <div class="ml-8">
                    <v-btn
                      @click="increment"
                      elevation="2"
                      color="rpdbutton"
                      light
                      class="white--text"
                      >Next Card</v-btn
                    >
                  </div>
                </div>
              </v-col> -->
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <!-- Barbs 52 card start -->
      <v-card elevation="2" tile class="pt-lg-4 pb-12">
        <v-card-title>
          <h3 data-v-372f198e="">All Cards</h3>
        </v-card-title>
        <v-card-subtitle style="word-break: break-word" class="black--text"
          >Cards with stars link to the Missing Persons page where you will find
          more information about that person.</v-card-subtitle
        >
        <!-- Spades -->
        <v-row id="cards-spades" class="spades">
          <!-- row 1 spades -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 spades-row1"
            cols="12"
          >
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#casper"
              target="_blank"
              title="Jennifer Casper-Ross"
              ><img
                src="../images/A_spades_star.png"
                lazy-src="../images/A_spades_star.png"
                class="single-card"
            /></a>

            <img
              src="../images/2_spades.png"
              lazy-src="../images/2_spades.png"
              class="single-card"
            />

            <img
              src="../images/3_spades.png"
              lazy-src="../images/3_spades.png"
              class="single-card"
            />

            <img
              src="../images/4_spades.png"
              lazy-src="../images/4_spades.png"
              class="single-card"
            />
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#layne"
              target="_blank"
              title="Gerald Layne"
              ><img
                src="../images/5_spades_star.png"
                lazy-src="../images/5_spades_star.png"
                class="single-card"
            /></a>
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#frisch"
              target="_blank"
              title="Roy Frisch"
              ><img
                src="../images/6_spades_star.png"
                lazy-src="../images/6_spades_star.png"
                class="single-card"
            /></a>

            <img
              src="../images/7_spades.png"
              lazy-src="../images/7_spades.png"
              class="single-card"
            />
          </v-col>

          <!-- row 2 spades -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 spades-row2 justify-lg-center"
            cols="12"
          >
            <img
              src="../images/8_spades.png"
              lazy-src="../images/8_spades.png"
              class="single-card"
            />

            <img
              src="../images/9_spades.png"
              lazy-src="../images/9_spades.png"
              class="single-card"
            />

            <img
              src="../images/10_spades.png"
              lazy-src="../images/10_spades.png"
              class="single-card"
            />

            <img
              src="../images/11_J_spades.png"
              lazy-src="../images/11_J_spades.png"
              class="single-card"
            />

            <img
              src="../images/12_Q_spades.png"
              lazy-src="../images/12_Q_spades.png"
              class="single-card"
            />

            <img
              src="../images/13_K_spades.png"
              lazy-src="../images/13_K_spades.png"
              class="single-card"
            />
          </v-col>
        </v-row>
        <!-- hearts -->
        <v-row id="cards-hearts" class="hearts">
          <!-- row 1 hearts -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 hearts-row1"
            cols="12"
          >
            <img
              src="../images/A_hearts.png"
              lazy-src="../images/A_hearts.png"
              class="single-card"
            />
            <img
              src="../images/2_hearts.png"
              lazy-src="../images/2_hearts.png"
              class="single-card"
            />

            <img
              src="../images/3_hearts.png"
              lazy-src="../images/3_hearts.png"
              class="single-card"
            />

            <img
              src="../images/4_hearts.png"
              lazy-src="../images/4_hearts.png"
              class="single-card"
            />

            <img
              src="../images/5_hearts.png"
              lazy-src="../images/5_hearts.png"
              class="single-card"
            />

            <img
              src="../images/6_hearts.png"
              lazy-src="../images/6_hearts.png"
              class="single-card"
            />

            <img
              src="../images/7_hearts.png"
              lazy-src="../images/7_hearts.png"
              class="single-card"
            />
          </v-col>

          <!-- row 2 hearts -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 hearts-row2 justify-lg-center"
            cols="12"
          >
            <img
              src="../images/8_hearts.png"
              lazy-src="../images/8_hearts.png"
              class="single-card"
            />

            <img
              src="../images/9_hearts.png"
              lazy-src="../images/9_hearts.png"
              class="single-card"
            />

            <img
              src="../images/10_hearts.png"
              lazy-src="../images/10_hearts.png"
              class="single-card"
            />

            <img
              src="../images/11_J_hearts.png"
              lazy-src="../images/11_J_hearts.png"
              class="single-card"
            />

            <img
              src="../images/12_Q_hearts.png"
              lazy-src="../images/12_Q_hearts.png"
              class="single-card"
            />

            <img
              src="../images/13_K_hearts.png"
              lazy-src="../images/13_K_hearts.png"
              class="single-card"
            />
          </v-col>
        </v-row>
        <!-- clubs -->
        <v-row id="cards-clubs" class="clubs">
          <!-- row 1 clubs -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 clubs-row1"
            cols="12"
          >
            <img
              src="../images/A_clubs.png"
              lazy-src="../images/A_clubs.png"
              class="single-card"
            />
            <img
              src="../images/2_clubs.png"
              lazy-src="../images/2_clubs.png"
              class="single-card"
            />

            <img
              src="../images/3_clubs.png"
              lazy-src="../images/3_clubs.png"
              class="single-card"
            />

            <img
              src="../images/4_clubs.png"
              lazy-src="../images/4_clubs.png"
              class="single-card"
            />

            <img
              src="../images/5_clubs.png"
              lazy-src="../images/5_clubs.png"
              class="single-card"
            />

            <img
              src="../images/6_clubs.png"
              lazy-src="../images/6_clubs.png"
              class="single-card"
            />

            <img
              src="../images/7_clubs.png"
              lazy-src="../images/7_clubs.png"
              class="single-card"
            />
          </v-col>

          <!-- row 2 clubs -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 clubs-row2 justify-lg-center"
            cols="12"
          >
            <img
              src="../images/8_clubs.png"
              lazy-src="../images/8_clubs.png"
              class="single-card"
            />

            <img
              src="../images/9_clubs.png"
              lazy-src="../images/9_clubs.png"
              class="single-card"
            />

            <img
              src="../images/10_clubs.png"
              lazy-src="../images/10_clubs.png"
              class="single-card"
            />

            <img
              src="../images/11_J_clubs.png"
              lazy-src="../images/11_J_clubs.png"
              class="single-card"
            />

            <img
              src="../images/12_Q_clubs.png"
              lazy-src="../images/12_Q_clubs.png"
              class="single-card"
            />

            <img
              src="../images/13_K_clubs.png"
              lazy-src="../images/13_K_clubs.png"
              class="single-card"
            />
          </v-col>
        </v-row>
        <!-- diamonds -->
        <v-row id="cards-diamonds" class="diamonds">
          <!-- row 1 diamonds -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 diamonds-row1"
            cols="12"
          >
            <img
              src="../images/A_diamonds.png"
              lazy-src="../images/A_diamonds.png"
              class="single-card"
            />
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#fourcher"
              target="_blank"
              title=""
              ><img
                src="../images/2_diamonds_star.png"
                lazy-src="../images/2_diamonds_star.png"
                class="single-card"
            /></a>
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#palumbo"
              target="_blank"
              title="Star Palumbo"
              ><img
                src="../images/3_diamonds_star.png"
                lazy-src="../images/3_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#girard"
              target="_blank"
              title="Roberta Girard"
              ><img
                src="../images/4_diamonds_star.png"
                lazy-src="../images/4_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#dasilva"
              target="_blank"
              title="Monica DeSilva"
              ><img
                src="../images/5_diamonds_star.png"
                lazy-src="../images/5_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#taylor"
              target="_blank"
              title="Linda Taylor"
              ><img
                src="../images/6_diamonds_star.png"
                lazy-src="../images/6_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#beaty"
              target="_blank"
              title="Jill Kristine Beaty"
              ><img
                src="../images/7_diamonds_star.png"
                lazy-src="../images/7_diamonds_star.png"
                class="single-card"
            /></a>
          </v-col>

          <!-- row 2 diamonds -->
          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 diamonds-row2 justify-lg-center"
            cols="12"
          >
            <img
              src="../images/8_diamonds.png"
              lazy-src="../images/8_diamonds.png"
              class="single-card"
            />

            <img
              src="../images/9_diamonds.png"
              lazy-src="../images/9_diamonds.png"
              class="single-card"
            />
            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#corpuz"
              target="_blank"
              title="Jeanette Corpuz"
              ><img
                src="../images/10_diamonds_star.png"
                lazy-src="../images/10_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#chia_c"
              target="_blank"
              title="Charles and Jennifer Chia"
              ><img
                src="../images/11_J_diamonds_star.png"
                lazy-src="../images/11_J_diamonds_star.png"
                class="single-card"
            /></a>

            <a
              class="clicky-img mt-2"
              href="https://renopd.com/missing/#denison"
              target="_blank"
              title="Caitlin Denison"
              ><img
                src="../images/12_Q_diamonds_star.png"
                lazy-src="../images/12_Q_diamonds_star.png"
                class="single-card"
            /></a>

            <img
              src="../images/13_K_diamonds.png"
              lazy-src="../images/13_K_diamonds.png"
              class="single-card"
            />
          </v-col>
        </v-row>

        <!-- jokers -->
        <v-row id="cards-jokers" class="jokers-misc">
          <!-- row 1 diamonds -->

          <v-col
            class="d-flex flex-lg-row flex-sm-row justify-sm-center flex-sm-wrap flex-column align-center col-lg-12 diamonds-row1"
            cols="12"
          >
            <img
              src="../images/joker.png"
              lazy-src="../images/joker.png"
              class="single-card"
            />
            <img
              src="../images/joker_about.png"
              lazy-src="../images/joker_about.png"
              class="single-card"
            />
            <img
              src="../images/joker_call_sw.png"
              lazy-src="../images/joker_call_sw.png"
              class="single-card"
            />
            <img
              src="../images/joker_deck.png"
              lazy-src="../images/joker_deck.png"
              class="single-card"
            />
            <img
              src="../images/back_of_deck.png"
              lazy-src="../images/back_of_deck.png"
              class="single-card"
            />
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
/* 0 media q */

@media (min-width: 0px) {
  .podcasts img {
    box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);
    -webkit-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);
    -moz-box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.5);
  }

  .value-pair label {
    font-size: 1.1rem;
    font-weight: 800;
    color: black;
  }
  .value-pair article {
    font-size: 1.1rem;
    font-weight: 500;
    font-style: italic;
    color: black;
  }
  /*   .single-card {
    width: 90%;
  } */
}

.spades img,
.hearts img,
.clubs img,
.diamonds img,
.clicky-img,
/* .spotimage img, */
.jokers-misc img {
  width: 90%;
}

.single-spot {
  width: 90%;
}

.single-spot a {
  width: 100%;
}

.single-spot img {
  width: 100%;
}
div .single-spot img {
  width: 100%;
}

.spades .clicky-img img,
.diamonds .clicky-img img
/* .spotimage .clicky-img img */ {
  width: 100%;
}

/* 768 media q */
@media (min-width: 768px) {
  .spades img,
  .hearts img,
  .clubs img,
  .diamonds img,
  .clicky-img,
  /* .spotimage img, */
  .jokers-misc img {
    width: 31%;
  }

  .single-spot {
    width: 34%;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .spades img,
  .hearts img,
  .clubs img,
  .diamonds img,
  .clicky-img,
  /* .spotimage img, */
  .jokers-misc img {
    width: 24%;
  }

  .single-spot {
    width: 22%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  /*   .spotimage {
    width: 20%;
  } */

  .spades img,
  .hearts img,
  .clubs img,
  .diamonds img,
  .clicky-img,
  /* .spotimage img, */
  .jokers-misc img {
    width: 14%;
  }

  .single-spot {
    width: 15%;
  }
}

.single-card {
  width: 251px;
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "image_gallery",
  mixins: [bus_common],
  data() {
    return {
      // <a
      //         class="clicky-img mt-2"
      //         href="https://renopd.com/missing/#casper"
      //         target="_blank"
      //         title="Jennifer Casper-Ross"
      //         ><img
      //           src="../images/A_spades_star.png"
      //           lazy-src="../images/A_spades_star.png"
      //           class="single-card"
      //       /></a>
      dialog: false,
      cardindex: -1,
      cardindex2: -1,
      cardindex3: -1,
      cardindex4: -1,
      cards: [
        {
          name: "Jennifer Casper-Ross",
          src: "/images/A_spades_star.png",
          href: `https://renopd.com/missing/#casper`,
          casenum: "05-17391",
        },
        {
          name: "Gerald Layne",
          src: "/images/5_spades_star.png",
          href: `https://renopd.com/missing/#layne`,
          casenum: "19-25014",
        },
        {
          name: "Roy Frisch",
          src: "/images/6_spades_star.png",
          href: `https://renopd.com/missing/#frisc`,
          casenum: "96-162608",
        },

        {
          name: "Terri Ann Fourcher",
          src: "/images/2_diamonds_star.png",
          href: "https://renopd.com/missing/#fourcher",
          casenum: "96-233769",
        },
        {
          name: "Star Palumbo",
          src: "images/3_diamonds_star.png",
          href: "https://renopd.com/missing/#palumbo",
          casenum: "00-176028",
        },
        {
          name: "Roberta T. Girard",
          src: "images/4_diamonds_star.png",
          href: "https://renopd.com/missing/#girard",
          casenum: "93-245921",
        },
        {
          name: "Monica DaSilva",
          src: "images/5_diamonds_star.png",
          href: "https://renopd.com/missing/#dasilva",
          casenum: "90-168641",
        },
        {
          name: "Linda Lou Taylor",
          src: "images/6_diamonds_star.png",
          href: "https://renopd.com/missing/#taylor",
          casenum: "79-31147",
        },
        {
          name: "Jill Kristine Beaty",
          src: "images/7_diamonds_star.png",
          href: "https://renopd.com/missing/#beaty",
          casenum: "94-222983",
        },
        {
          name: "Jeanette Marie Corpuz",
          src: "images/10_diamonds_star.png",
          href: "https://renopd.com/missing/#corpuz",
          casenum: "03-3825",
        },
        {
          name: "Charles and Jennifer Chia",
          src: "images/11_J_diamonds_star.png",
          href: "https://renopd.com/missing/#chia",
          casenum: "89-159427",
        },
        {
          name: "Caitlin Denison",
          src: "images/12_Q_diamonds_star.png",
          href: "https://renopd.com/missing/#denison",
          casenum: "18-2364",
        },
      ],
    };
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    increment() {
      var index = Number(localStorage.getItem("cardindex"));
      if (index == null) {
        this.cardindex = 0;
        console.log("null: " + index);
      } else {
        this.cardindex = index + 1;
        console.log("null: " + index);
        if (this.cardindex > this.cards.length - 1) {
          this.cardindex = 0;
        }
      }
      this.cardindex2 = this.cardindex + 1;
      if (this.cardindex2 > this.cards.length - 1) {
        this.cardindex2 = 0;
      }

      this.cardindex3 = this.cardindex2 + 1;
      if (this.cardindex3 > this.cards.length - 1) {
        this.cardindex3 = 0;
      }
      this.cardindex4 = this.cardindex3 + 1;
      if (this.cardindex4 > this.cards.length - 1) {
        this.cardindex4 = 0;
      }
      localStorage.setItem("cardindex", this.cardindex);
    },
    init() {
      this.increment();
      var seen = Number(localStorage.getItem("intro_seen"));
      if (seen != true) {
        this.dialog = true;
        localStorage.setItem("intro_seen", "true");
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
